import React from 'react';
import { graphql } from 'gatsby';
import useStoryblok from '~/utils/storyblok-service';
import Image from '~/components/Dynamic/Image';

import Layout from '~/components/Layout';
import Seo from '~/components/SEO';
import TextCard from '~/components/TextCard';
import DynamicComponent from '~/components/DynamicComponent';



const UseCase = ({ data, location, pageContext }) => {
  const story = useStoryblok(data.story, location);
  const hero = story.content.Hero[0];

  const components = story?.content?.content?.map((blok) => {
    return <DynamicComponent blok={blok} key={blok._uid} />;
  });

  return (
    <Layout locale={pageContext.locale}>
      <Seo {...story.seo} lang={story.lang} pageContext={pageContext} />

      {hero && (
        <section className={`pt-10 mb-20 md:mb-24 -mt-20 ${story.content.heroColor || 'bg-cream'}`}>
          <div className="container pt-24 pt-42">
            <div className="flex flex-wrap items-center -ml-16 md:-ml-24">
              <div className="flex pl-16 md:pl-24 md:w-6/12">
                <TextCard
                  tag={`h1`}
                  className="items-center max-w-xl mx-auto text-center md:text-left md:ml-0 md:items-start"
                  headingClass={`md:text-h2 lg:text-h1`}
                  contentClass={`text-20px max-w-lg`}
                  {...hero.textCard[0]}
                />
              </div>
              <div className="flex flex-col w-full pl-16 mt-16 mb-16 md:pl-24 md:mt-0 md:w-1/2 md:mb-0">
                <Image blok={hero.asset[0]} />
              </div>
            </div>
          </div>

          <div className="container py-16 pt-0 md:pt-16">
            {story?.content?.Logos?.length > 0 && (
              <div className="grid items-center justify-center grid-cols-2 gap-5 mx-auto md:grid-cols-6">
                {story.content.Logos?.map((logo, i) => (
                  <div key={`logo${logo.filename}`} className="flex items-center justify-center py-4 lg:justify-center">
                    <img src={logo.filename} alt={logo.alt} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {components}

    </Layout>
  );
};

export default UseCase;

export const query = graphql`
  query UseCaseQuery($id: String!) {
    story: storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
